/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeprecatedProjectIndicatorJS_project$ref: FragmentReference;
declare export opaque type DeprecatedProjectIndicatorJS_project$fragmentType: DeprecatedProjectIndicatorJS_project$ref;
export type DeprecatedProjectIndicatorJS_project = {|
  +name: ?string,
  +companyProjectId: ?number,
  +customProjectId: ?string,
  +projectColor: ?string,
  +$refType: DeprecatedProjectIndicatorJS_project$ref,
|};
export type DeprecatedProjectIndicatorJS_project$data = DeprecatedProjectIndicatorJS_project;
export type DeprecatedProjectIndicatorJS_project$key = {
  +$data?: DeprecatedProjectIndicatorJS_project$data,
  +$fragmentRefs: DeprecatedProjectIndicatorJS_project$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeprecatedProjectIndicatorJS_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColor",
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
// prettier-ignore
(node/*: any*/).hash = '0c04892525d87c46f0014f37dcbc2036';

module.exports = node;
